module.exports = __webpack_public_path__ + "img/amaro-mobile.70e38e36.png";